import React from 'react';

import './Contact.scss';

type ContactProps = {
    title : string
    person? : {
        email : string
        emailLabel : string
        image : string
        name : string
        phone : string
        title : string
    }
    text? : string
    translationPath? : string
}

export default function Contact({title, person, text} : ContactProps) {
    return (
        <div className="career-model__contact">
            <h3 className="career-model__contact--title">{title}</h3>
            {person &&
                <div className="career-model__person">
                    <div className="career-model__person--image">
                        <img src={person.image} alt={person.name}/>
                    </div>
                    <div className="career-model__person--info">
                        <div className="career-model__person--name">
                            {person.name}
                        </div>
                        <div className="career-model__person--title">
                            {person.title}
                        </div>
                        <div className="career-model__person--phone">
                            <a href={'tel:' + person.phone}>
                                <svg className="career-model__person--phone-icon" xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 21 21">
                                    <path
                                        d="M15.2212,12.252l-2.56-.336h.0001a.64016.64016,0,0,0-.5073.16l-1.3407,1.1744A14.29168,14.29168,0,0,1,7.46759,9.13351l1.408-.96a.64018.64018,0,0,0,.27678-.48l.2192-2.68472a1.13449,1.13449,0,0,0-.99843-1.22088L5.8676,3.49029a1.11972,1.11972,0,0,0-.90557.31037,1.189,1.189,0,0,0-.33917.7328L4.49328,5.73023c-.18716,1.93917.8,4.56,2.56006,6.84,1.88314,2.4256,4.20976,3.968,6.384,4.2303l1.2496.1313-.0001.0001a1.24782,1.24782,0,0,0,.1408-.0017A1.09282,1.09282,0,0,0,15.93,15.9254l.2911-2.4416a1.14383,1.14383,0,0,0-.9967-1.24Z"
                                        fill="currentColor"/>
                                </svg>
                                {person.phone}
                            </a>
                        </div>
                        <div className="career-model__person--email">
                            <a href={person.email}>
                                <svg className="career-model__person--email-icon" xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 21 21">
                                    <path
                                        d="M15.7305,5.8722a1.25467,1.25467,0,0,1,1.255,1.25524V14.5278a1.25541,1.25541,0,0,1-1.255,1.2553H4.44061a1.25477,1.25477,0,0,1-1.25506-1.2553V7.12744A1.25542,1.25542,0,0,1,4.44061,5.8722ZM9.10208,11.5391,4.63771,8.00476c-.10886-.08628-.1976-.04463-.1976.09328V14.2788a.24991.24991,0,0,0,.25168.2498H15.4794a.25016.25016,0,0,0,.2517-.2498V8.098c0-.13931-.0886-.17974-.1976-.09328L11.0691,11.5391a1.66128,1.66128,0,0,1-1.96684,0ZM14.3693,7.12673H5.80178c-.13739,0-.1647.069-.05706.15419L9.79148,10.4846a.495.495,0,0,0,.588,0l4.0468-3.20368c.1083-.08576.0821-.15419-.0571-.15419Z"
                                        fill="currentColor" fillRule="evenodd"/>
                                </svg>
                                {person.emailLabel}
                            </a>
                        </div>
                    </div>
                </div>
            }
            {text &&
                <p className="career-model__contact--text"
                   dangerouslySetInnerHTML={{__html: text}}></p>
            }
        </div>
    );
};
